<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M0 4.21875C0 1.8888 1.8888 1.84407e-07 4.21875 1.84407e-07C6.5487 1.84407e-07 8.4375 1.8888 8.4375 4.21875V6.1875C8.4375 7.43014 7.43014 8.4375 6.1875 8.4375H4.21875C1.8888 8.4375 0 6.5487 0 4.21875Z"
    />
    <path
      d="M18 13.7812C18 16.1112 16.1112 18 13.7812 18C11.4513 18 9.5625 16.1112 9.5625 13.7812L9.5625 11.8125C9.5625 10.5699 10.5699 9.5625 11.8125 9.5625H13.7813C16.1112 9.5625 18 11.4513 18 13.7812Z"
    />
    <path
      d="M13.7812 0C16.1112 1.01845e-07 18 1.8888 18 4.21875C18 6.5487 16.1112 8.4375 13.7812 8.4375H11.8125C10.5699 8.4375 9.5625 7.43014 9.5625 6.1875V4.21875C9.5625 1.8888 11.4513 -1.01845e-07 13.7812 0Z"
    />
    <path
      d="M4.21875 18C1.8888 18 2.47686e-07 16.1112 5.53222e-07 13.7812C8.58758e-07 11.4513 1.8888 9.5625 4.21875 9.5625H6.1875C7.43014 9.5625 8.4375 10.5699 8.4375 11.8125V13.7813C8.4375 16.1112 6.5487 18 4.21875 18Z"
    />
  </svg>
</template>
